import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import React, { FC, Fragment, useEffect, useRef, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { CouponType, EventType, LocalitySelectedType, PhaseType, SeatsSelectedType, UserType } from "data/types";
import { useGetEventQuery, useGetPhasesByEventMutation, useLazyVerifyCouponQuery, useVerifyCouponLocalityMutation } from "store/api";
import {  useParams } from "react-router-dom";
import NcInputNumberLocalities from "./NcInputNumberLocalities/NcInputNumberLocalities";
import Input from "shared/Input/Input";
import { Loading } from "./Loading/Loading";
import { TimerProvider } from "contexts/TimerContext";

interface ModalSelectDateProps {
  renderChildren?: (p: { openModal: () => void }) => React.ReactNode;
}

const ModalSelectTickets: FC<ModalSelectDateProps> = ({ renderChildren }) => {
 const { id } = useParams();
   const [event,setEvent] = useState<EventType|null>(null);
   const {data,isLoading}= useGetEventQuery(id);
   useEffect(() => {
      if(data){
           const item = data.eventDB;
           const eventSelected:EventType= {
             _id:item._id,
             nameEvent:item.nameEvent,
             date:item.date,
             category:item.category,
             city:{
               _id:item.city._id,
               description:item.city.description,
               province: item.city.province,
             },
             acronym:item.acronym,
             description:item.description,
             payments:item.payments,
             sponsors:item.sponsors,
             existRequirements:item.existRequirements,
             requirementsDescription:item.requirementsDescription,
             place:item.place,
             available:item.available,
             publicType:item.publicType,
             startTime:item.startTime,
             endTime:item.endTime,
             isFree:item.isFree,
             isDelete:item.isDelete,
             img:item.img,
             lat:item.lat,
             lng:item.lng,
             secretLocation:item.secretLocation,
             iva:item.iva,
             hasCapacity:item.hasCapacity,
             maximunTickets:item.maximunTickets,
             valueIva:item.valueIva,
             imgHeader:item.imgHeader,
             haveSubscribers:item.haveSubscribers,
             haveDistribution:item.haveDistribution,
             type:item.type,
             publicationDate:item.publicationDate,
             publicationTime:item.publicationTime,
             specialDiscounts:item.specialDiscounts,
             percentageSpecialDiscounts:item.percentageSpecialDiscounts,
             imgDistributionPlace:item.imgDistributionPlace,
             localitiesFrom:item.localitiesFrom,
             salesman:item.salesman,
           }
           setEvent(eventSelected);
         }
     
 
   }
   , [data]);
   return (
    !event?<Loading/>:<ModalSelectTicketsEvent renderChildren={renderChildren} event={event}/>
   );
};

export default ModalSelectTickets;

interface ModalSelectDateEventProps {
  renderChildren?: (p: { openModal: () => void }) => React.ReactNode;
  event: EventType;
}
const ModalSelectTicketsEvent: FC<ModalSelectDateEventProps> = ({ renderChildren,event }) => {

  
  const [showModal, setShowModal] = useState(false);
  const [rowValues, setRowValues] = useState<Record<string, number>>({});
  const [subtotal0, setSubtotal0] = useState(0);
  const [subtotal15, setSubtotal15] = useState(0);
  const [vat, setVat] = useState(0);
  const [totalCommision, setTotalCommision] = useState(0);
  const [totalCommisionVat, setTotalCommisionVat] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [subtotalVat, setSubtotalVat] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [total, setTotal] = useState(0);
  const currentTime = new Date();
  const [cantTickets, setCantTickets] = useState(0);
  const timer = useRef<NodeJS.Timeout | null>(null);
  const [coupon,setCoupon]= useState('');
  const [couponMessageError, setCouponMessageError] = useState('');
  const [verifyCoupon] = useLazyVerifyCouponQuery();
  const [verifyCouponLocality] = useVerifyCouponLocalityMutation();
  const [localities, setLocalities] = useState<any[]>([]);
  const [verifyingCoupon, setVerifyingCoupon] = useState(false);
  const [localitiesSelected, setLocalitiesSelected] = useState<LocalitySelectedType[]>([]);
  
 useEffect(() => {
   let newSubtotal0 = 0;
   let newSubtotal15 = 0;
   let newVat = 0;
   let newTotalCommision = 0;
   let newTotalCommisionVat = 0;
   let newTotal = 0;
   let newSubtotal = 0;
   if (event.iva) {
     newSubtotal15 = phases.reduce((acc, phase) => {
       const rowValue = rowValues[phase.description] || 0;
       return acc + rowValue * (parseFloat(phase.priceWithVAT)/(1+(event.valueIva/100)));
     }, 0);
     setSubtotal15(newSubtotal15);
 
     newSubtotal = phases.reduce((acc, phase) => {
       const rowValue = rowValues[phase.description] || 0;
       return acc + rowValue * +phase.priceWithVAT;
     }, 0);
     setSubtotalVat(newSubtotal);
 
     newVat =  newSubtotal15 * (event.valueIva / 100);
     setVat(newSubtotal-newSubtotal15);
 
     newTotalCommision = phases.reduce((acc, phase) => {
       const rowValue = rowValues[phase.description] || 0;
       return acc + rowValue * (parseFloat(phase.commisionIva)/(1+(event.valueIva/100)));
     }, 0);
     setTotalCommision(newTotalCommision);
     newTotalCommisionVat = newTotalCommision * (event.valueIva / 100);
     setTotalCommisionVat(newTotalCommisionVat);
 
     const totalWithVat = newSubtotal15 + newVat + newTotalCommision + newTotalCommisionVat;
     setSubtotal(totalWithVat);
 
     newTotal = phases.reduce((acc, phase) => {
       const rowValue = rowValues[phase.description] || 0;
       return acc + rowValue * +phase.priceWithVAT;
     }, 0);
     setTotal(totalWithVat-discount);
 
   } else {
     newSubtotal0 = phases.reduce((acc, phase) => {
       const rowValue = rowValues[phase.description] || 0;
       return acc + rowValue * +phase.priceWithoutVAT;
     }, 0);
     setSubtotal0(newSubtotal0);
 
     newTotalCommision = phases.reduce((acc, phase) => {
       const rowValue = rowValues[phase.description] || 0;
       return acc + rowValue * +phase.commisionNoIva;
     }, 0);
     setTotalCommision(newTotalCommision);
 
     newTotalCommisionVat = newTotalCommision * (15 / 100);
     setTotalCommisionVat(newTotalCommisionVat);
 
     newSubtotal = phases.reduce((acc, phase) => {
       const rowValue = rowValues[phase.description] || 0;
       return acc + rowValue * +phase.priceWithVAT;
     }, 0);
     const subt = newSubtotal+newTotalCommision+newTotalCommisionVat;
     setSubtotal(subt);
 
     newTotal = phases.reduce((acc, phase) => {
       const rowValue = rowValues[phase.description] || 0;
       return acc + rowValue * +phase.priceWithVAT;
     }, 0);
     setTotal(subt-discount);
    }
 
    setCantTickets(phases.reduce((acc, phase) => {
     const rowValue = rowValues[phase.description] || 0;
     return acc + rowValue;
   }
   , 0));
   if(cantTickets===0){
     setDiscount(0);
     setCoupon('');
   } 
 // }, [rowValues, phases, event]);
 }, [rowValues, event, discount]);
 
   const handleRowChange = (value: number, phase: PhaseType) => {
     setDiscount(0);
     setRowValues((prev) => ({
       ...prev,
       [phase.description]: value,
     }));
     setLocalities((prev) => {
       const existingLocalityIndex = prev.findIndex(
           (loc) => loc[0] === phase.locality
       );
 
       if (existingLocalityIndex >= 0) {
           prev[existingLocalityIndex][1] = value;
           prev[existingLocalityIndex][3] = +phase.priceWithVAT;
           return [...prev];
       } else {
           return [...prev, [phase.locality, value, false, +phase.priceWithVAT]];
       }
   });
   };
  

  function closeModal() {
    setShowModal(false);
  }

  function openModal() {
    setShowModal(true);
  }

  const renderButtonOpenModal = () => {
    return renderChildren ? (
      renderChildren({ openModal })
    ) : (
      <button onClick={openModal}>Select Date</button>
    );
  };
  
  const [phases, setPhases] = useState<PhaseType[]>([]); 

const [getPhasesByEvent,{data}]=useGetPhasesByEventMutation();
  const [hasDataChanged, setHasDataChanged] = useState(false); 

  useEffect(() => {
    getPhasesByEvent({event:event._id});
  }
  , [getPhasesByEvent]);
  

useEffect(() => {
  if (data && !hasDataChanged) {
    const newPhases = data?.localities?.map((localities: any) => {
      return localities.phases.map((phase: any) => ({
        _id: phase._id,
        status: phase.status,
        public: phase.public,
        position: phase.position,
        type: phase.type,
        name: phase.name,
        stock: phase.stock,
        typePublic: phase.typePublic,
        priceWithVAT: phase.priceWithVAT,
        priceWithoutVAT: phase.priceWithoutVAT,
        startDate: phase.startDate,
        endDate: phase.endDate,
        locality: phase.locality,
        log: phase.log,
        commisionIva: phase.commisionIva,
        commisionNoIva: phase.commisionNoIva,
        acronym: phase.acronym,
        description: localities.description,
        sequenceStart: phase.sequenceStart,
        typeNumbering: localities.typeNumbering,
        localityStock: localities.stock,
      }));
    });

    setPhases(newPhases?.flat());
    setLocalitiesSelected(newPhases?.map((phase: any) => ({ _id: phase[0].locality, quantity: 0, zones: [] })));
    setHasDataChanged(true); 
  }
}, [data, hasDataChanged]);


  const userData = localStorage.getItem("user");
  let user:UserType;
  if (userData) {
    user = JSON.parse(userData) as UserType;
  }

  const handleDiscount = async (e:React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if(timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(async() => {
      setCoupon(value);
      await verifyDiscount(value);
    }, 500);
  }

const verifyDiscount = async(coupon:string)=>{
  if(coupon==='') {
    setCouponMessageError('');
    setDiscount(0);
    return;
  }
  setVerifyingCoupon(true);
  const {data, error} = await verifyCoupon({code:coupon,customer:user._id,item:event._id,type:'events'});
      if(error){
        console.log(error);
        const fetchError = error as { status: number; data: { error: string; statusMessage: string } };
        if(fetchError.status === 400){
          if(fetchError.data.error === 'Validar por localidad') {
            await verifyDiscountByLocality(coupon);
          }else{
            setDiscount(0);
            setCouponMessageError('Cupón inválido');
            setVerifyingCoupon(false);
          }
        } 
      }
      if(data) {
        console.log(data);
        setCouponMessageError('');
        if(data.meta.status===200){
          const coupon:CouponType = {...data.coupon};
          if(coupon.typeDiscount==="PERCENTAGE")
            event.iva? setDiscount(((subtotal15+vat)*(coupon.valueDiscount/100))):
            setDiscount(((subtotal0+vat)*(coupon.valueDiscount/100)));
          else
            setDiscount(+coupon.valueDiscount)
          setVerifyingCoupon(false);
        }
      }
}

const verifyDiscountByLocality = async(code:string)=>{
  setCouponMessageError('');
  const prices = localities.map((locality) => {
    return locality[1]*locality[3];
  });
  const {data,error} = await verifyCouponLocality({code,body:{localities,prices}});
  if(error){
    console.log(error);
    const fetchError = error as { status: number; data: { error: string; statusMessage: string } };
    if(fetchError.status === 400){
      setDiscount(0);
      setCouponMessageError('Cupón inválido');
      setVerifyingCoupon(false);
    }
  }
  if(data){
    if(data.meta.status===200){
      console.log(data);
      const discounts = data.discounts;
      const discount = discounts.reduce((acc:any, discountLocal:any) => {
        return acc + discountLocal;
      }, 0);
      if(discount>0) setDiscount(discount);
      else setCouponMessageError('Cupón inválido');
      // else setCouponMessageError('Cupón inválido para esta(s) localidad(es)');
      setVerifyingCoupon(false);
    }
  }
}
useEffect(()=>{
  verifyDiscount(coupon);
},[total]);


  return (
    <>
      {renderButtonOpenModal()}
      <TimerProvider>
      <Transition appear show={showModal} as={Fragment}>
        <Dialog
          as="div"
          className="HeroSearchFormMobile__Dialog relative z-50"
          onClose={closeModal}
        >
          <div className="fixed inset-0 bg-neutral-100 dark:bg-neutral-900">
            <div className="flex h-full">
              <Transition.Child
                as={Fragment}
                enter="ease-out transition-transform"
                enterFrom="opacity-0 translate-y-52"
                enterTo="opacity-100 translate-y-0"
                leave="ease-in transition-transform"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-52"
              >
                <Dialog.Panel className="relative h-full overflow-hidden flex-1 flex flex-col justify-between ">
                  <>
                    <div className="absolute left-4 top-4">
                      <button
                        className="focus:outline-none focus:ring-0"
                        onClick={closeModal}
                      >
                        <XMarkIcon className="w-5 h-5 text-black dark:text-white" />
                      </button>
                    </div>

                    <div className="flex-1 pt-12 p-1 flex flex-col overflow-auto">
                      <div className="flex-1 flex flex-col bg-white dark:bg-neutral-800">
                        <div className="flex-1 flex flex-col transition-opacity animate-[myblur_0.4s_ease-in-out] overflow-auto">
                          <div className="p-5 ">
                          </div>
                          <div className="flex-1 relative flex z-10 ">
                            <div className="overflow-hidden rounded-3xl sm:rounded-md w-full p-2">
                              {
                                phases?.length > 0 && (
                                  phases.map((phase:PhaseType,index)=>(
                                    <NcInputNumberLocalities
                                      enablePurchase={currentTime>new Date(event.publicationTime)}
                                      startTime={event.publicationTime}
                                      localityId={phase.locality}
                                      key={index}
                                      className="w-full sm:w-full"
                                      onChange={(value) => handleRowChange(value, phase)}
                                      maxQuantity={event.maximunTickets}
                                      currentQuantity={cantTickets}
                                      max={phase.stock>phase.localityStock?phase.localityStock:phase.stock}
                                      min={0}
                                      label={phase.description.split("*")[0]}
                                      desc={`$${phase.priceWithVAT} ${phase.description.split("*")[1]?phase.description.split("*")[1]+'*':''}`}
                                      haveSelection={phase.typeNumbering==="Alfanumérico"}
                                      endTime={event.endTime}
                                      localitiesSelected={localitiesSelected}
                                      setLocalitiesSelected={setLocalitiesSelected}
                                    />
                                  ))
                                )
                              }
                               {!event.isFree && cantTickets > 0 &&<label className="block">
                                  <span className="text-neutral-800 dark:text-neutral-200 animate-fadeIn">
                                    Tienes un cupón?
                                  </span>
                                  <Input
                                    className="mt-1 animate-fadeIn"
                                    placeholder="Ingresa tu cupón aquí"
                                    maxLength={10}
                                    onChange={handleDiscount}
                                  />
                                  {couponMessageError !== '' && (
                                    <p className="mt-2 text-red-500 text-xs">{couponMessageError}</p>
                                  )}
                                </label>}
                                {phases?.length > 0&&<div className="listingSectionSidebar__wrap shadow-xl p-4 space-y-2 rounded-lg">
                                  <div className="flex justify-between">
                                    <span>Subtotal 0%:</span>
                                    <span>${subtotal0.toFixed(2)}</span>
                                  </div>
                                  <div className="flex justify-between">
                                    <span>Subtotal 15%:</span>
                                    <span>${subtotal15.toFixed(2)}</span>
                                  </div>
                                  <div className="flex justify-between">
                                    <span>IVA:</span>
                                    <span>${vat.toFixed(2)}</span>
                                  </div>
                                  <div className="flex justify-between">
                                    <span>Fee Bee:</span>
                                    <span>${totalCommision.toFixed(2)}</span>
                                  </div>
                                  <div className="flex justify-between">
                                    <span>Fee Bee IVA:</span>
                                    <span>${totalCommisionVat.toFixed(2)}</span>
                                  </div>
                                  <div className="flex justify-between">
                                    <span>Subtotal:</span>
                                    <span>${subtotal.toFixed(2)}</span>
                                  </div>
                                  <div className="flex justify-between text-red-500">
                                    <span>Descuento:</span>
                                    <span>${discount.toFixed(2)}</span>
                                  </div>
                                  <div className="flex justify-between font-bold border-t pt-2 text-green-500">
                                    <span>Total:</span>
                                    <span>${total.toFixed(2)}</span>
                                  </div>
                                </div>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="px-4 py-3 bg-white dark:bg-neutral-900 border-t border-neutral-200 dark:border-neutral-700 flex justify-between">
                      {/* <button
                        type="button"
                        className="underline font-semibold flex-shrink-0"
                        onClick={() => {
                          onChangeDate([null, null]);
                        }}
                      >
                        Limpiar
                      </button> */}
                      <ButtonPrimary
                        sizeClass="px-6 py-3 !rounded-xl"
                        onClick={() => {
                          closeModal();
                        }}
                      >
                        Guardar
                      </ButtonPrimary>
                    </div>
                  </>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      </TimerProvider>

    </>
  );
}
